import { useCallback } from "react"
import { Alert, Button } from "@motleyhand/design"
import type { Notification } from "./model"
import { NotificationType } from "./model"
import { useGetNotifications } from "./selectors"
import { useResendVerifyEmail } from "@/profile"
import useFlashMessages from "@/notification/useFlashMessages"

export default function Notifications() {
  const { notifications } = useGetNotifications()
  const resendEmail = useResendVerifyEmail()
  useFlashMessages()

  const getProps = useCallback(
    ({ type }: Notification) => {
      switch (type) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        case NotificationType.VerifyEmail:
          return {
            variant: "warning",
            action: (
              <Button variant="ghost" onClick={resendEmail}>
                Re-send confirmation email
              </Button>
            ),
          } as const
      }
    },
    [resendEmail],
  )

  if (!notifications?.length) {
    return null
  }

  return (
    <div className="flex flex-col gap-2 p-4">
      {notifications.map((notification) => (
        <Alert
          key={notification.id}
          {...getProps(notification)}
          title={notification.text}
        />
      ))}
    </div>
  )
}
